export default {
  inject: ['load'],
  data() {
    return {
      allHeartRhythmsForOther: [],
      heartRhythm: null,
    };
  },
  methods: {
    getListOfHeartRhythmsForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllHeartRhythms').then(() => {
        if (this.$store.state.heartRhythmModule.successFlag) {
          this.allHeartRhythmsForOther = this.$store.state.heartRhythmModule.allHeartRhythms;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.heartRhythmModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfHeartRhythmsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getHeartRhythmFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getHeartRhythm', id).then(() => {
        if (this.$store.state.heartRhythmModule.successFlag) {
          this.heartRhythm = this.$store.state.heartRhythmModule.heartRhythm;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.heartRhythmModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getHeartRhythmFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.heartRhythmModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
